import { api } from "..";

import { RiskConfig } from "@/types/ApiResponses/Risk";

export interface UpdateRiskConfigBody {
  threshold?: number;
  leagueThreshold?: number;
  enabled?: boolean;
}

export const updateRiskConfig = async (
  body: UpdateRiskConfigBody
): Promise<RiskConfig> => {
  const res = await api.client.put("/risk/config", body);
  return res.data;
};
